import { CurrencyField } from '../models/organization-config-enums';

/**
 * The display symbol for a given currency (e.g. GBP -> "£", USD/AUD/CAD -> "$").
 *
 * Framework-agnostic so it can run under plain Node.js (see reporting-core
 * README) — the scheduled emailed-reports service needs the currency symbol to
 * render report tables, and it has no access to OrganizationConfigService.
 * That service now delegates here so there is a single source of truth.
 */
export function getCurrencySymbolForCurrency(currency: CurrencyField | null | undefined): string {
  switch (currency) {
    case CurrencyField.gbp:
      return '£';
    case CurrencyField.usd:
    case CurrencyField.aud:
    case CurrencyField.cad:
      return '$';
    case CurrencyField.thb:
      return '฿';
    default:
      return '';
  }
}
